import { createContext, type RefObject, useContext } from 'react';
import type { CountdownFinishHandler, TimerAPI } from '@elfsight/widget-ui';

interface TimerState {
  timer: {
    ref: RefObject<TimerAPI>;
    handleCountdownFinish: CountdownFinishHandler;
    handleCountdownReset: () => void;
    handleCountdownRestart: () => void;
    isVisible: boolean;
  };
}

interface HeadingState {
  heading: {
    text: string;
  };
}

export interface ButtonProps {
  id: string;
  onClick: () => void;
  text: string;
  isPrimary: boolean;
}
interface ButtonsState {
  buttons: ButtonProps[];
}

type ElementsContextType = TimerState & HeadingState & ButtonsState;

export const ElementsContext = createContext<ElementsContextType>({
  timer: {
    ref: { current: null },
    isVisible: true,
    handleCountdownFinish: () => {},
    handleCountdownReset: () => {},
    handleCountdownRestart: () => {}
  },
  heading: {
    text: ''
  },
  buttons: []
});

export const useElements = () => {
  return useContext(ElementsContext);
};
